export enum RoleClaimScope {
	All = 'All',
	Self = 'Self',
	Project = 'Project',
	Team = 'Team',
	Organization = 'Organization',
	None = 'None',
}